/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UploadingFileFromJSON, UploadingFileToJSON } from './UploadingFile';
export function UpdateMeAvatarRequestUserFromJSON(json) {
    return UpdateMeAvatarRequestUserFromJSONTyped(json, false);
}
export function UpdateMeAvatarRequestUserFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        avatar: !exists(json, 'avatar') ? undefined : UploadingFileFromJSON(json['avatar'])
    };
}
export function UpdateMeAvatarRequestUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        avatar: UploadingFileToJSON(value.avatar)
    };
}
